import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import TopBar from '../../components/TopBar'
import { useAnalytics } from '../../context/AnalyticsContext'
import { getOnboarding, setOnboarding } from './onboardingStorage'
import './onboarding.css'

const OPTIONS = [
  { key: 'men', labelKey: 'onboarding.lookingForMen' },
  { key: 'women', labelKey: 'onboarding.lookingForWomen' },
  { key: 'both', labelKey: 'onboarding.lookingForBoth' }
]

const OnboardingLookingFor = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { trackEvent } = useAnalytics()
  const [value, setValue] = useState('')

  useEffect(() => {
    const saved = getOnboarding()
    if (saved.lookingFor) setValue(saved.lookingFor)
  }, [])

  const onBack = () => navigate('/onboarding/interests')

  const pick = (key) => {
    setValue(key)
    setOnboarding({ lookingFor: key })
    trackEvent('funnel_looking_for_completed', { step: 5, lookingFor: key })
    navigate('/onboarding/reading')
  }

  return (
    <div className="onboarding-page">
      <TopBar currentStep={5} totalSteps={10} onBack={onBack} showBack={true} />
      <div className="onboarding-content">
        <h1 className="h1">{t('onboarding.lookingForTitle')}</h1>
        <p className="p">{t('onboarding.lookingForSubtitle')}</p>

        <div className="chips one">
          {OPTIONS.map((o) => (
            <button key={o.key} className={`chip ${value === o.key ? 'active' : ''}`} onClick={() => pick(o.key)}>
              {t(o.labelKey)}
            </button>
          ))}
        </div>
      </div>
    </div>
  )
}

export default OnboardingLookingFor

